import { Line } from "rc-progress";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { enrollModal, showModal } from "../../redux/actions";
import * as image from "../../resources/images";
const GoalSubmitPopUp = ({ closePopUp, courseIndex, handleSelectedCourse, handleUndo }) => {
  const [timeoutId, setTimeoutId] = useState();
  const [intevelId, setIntevelId] = useState();
  const [getCount, setCount] = useState(0);
  useEffect(() => {
    let getTimeoutId = setTimeout(() => {
      handleSelectedCourse(courseIndex + 1, true);
      closePopUp();
    }, 11000);

    let interval = setInterval(() => {
      setCount(prevCount => prevCount + 1);
    }, 1000); // This sets the interval to 1000 milliseconds (1 second)

    setTimeoutId(getTimeoutId);
    setIntevelId(interval);

    return () => clearInterval(interval);

  }, []);
  const handleRetry = () => {
    clearTimeout(timeoutId);
    clearInterval(intevelId);
    handleUndo();
    closePopUp();
    
  }
  // console.log("timeoutId @@@ : ", timeoutId, intevelId, "second : ", getCount);
  return (
    <div className="smallpopup notoficationsmalpoup ">
      <div className="modal d-flex" id="schoolactivity6" role="dialog">
        <div className="modal-dialog modal-lg">
          <div className="modal-content my_popup p-0">
            <div className="modal-body paymentinfo p-0">
              <div className="notificationbar">
                <Line percent={100 - (getCount * 10)} strokeWidth={1} strokeColor="#107C10" />
                <p className="flexone p1">
                  <span>
                    <img
                      src={image.notification_check}
                      className="mr-2"
                      alt="check "
                    />
                    KR Successfully Updated
                  </span>{" "}
                  <span className="Acrntxt pointer" onClick={() => handleRetry()}>
                    Undo<span></span>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default GoalSubmitPopUp;
